// extracted by mini-css-extract-plugin
module.exports = {"ProseMirror":"MenuItemRest_ProseMirror__x-zfx","menuItemRest":"MenuItemRest_menuItemRest__3CoLS","menuItemRest__icon":"MenuItemRest_menuItemRest__icon__UgY7g"};